import { createFileRoute, redirect } from "@tanstack/react-router";
import { isAuthenticated } from "@/auth/store";

// Bare `/` — punt to /app if logged in, /login otherwise.
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: isAuthenticated() ? "/app" : "/login" });
  },
});
